import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import "./Loader.scss";

function Loader({ loading }) {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => {
        setHidden(true);
      }, 350);
    }
  }, [loading]);

  return (
    <div
      className={`appLoader ${!loading ? "fade" : ""}
    ${hidden ? "hidden" : ""}
    `}
    >
      <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="logo" />
    </div>
  );
}

Loader.propTypes = {};

export default Loader;
